import { DayName } from "uitk-react-new-date-picker";
import { GtConfig } from "../typings";
import { timeValues } from "src/components/shared/TimeDropdown/config";
import { locKeys } from "src/components/flexComponents/WizardCarPWA/components/l10n";

const commonDateProps = {
  ISOSubmissionSupport: true,
  format: "yyyy-MM-dd",
  submissionFormat: "yyyy-MM-dd",
  firstDayOfWeek: DayName.SUN,
  daysBookableInAdvance: 500,
  maxDaysRange: 331,
  invalidStartDateMessageToken: "wizard.datePicker.warning.invalidDepartingDate.text",
  invalidEndDateMessageToken: "wizard.datePicker.warning.invalidReturningDate.text",
  invalidMaxDatesRangeMessageToken: "wizard.datePicker.warning.maxDatesRange.text",
  invalidStartDateOutOfRangeMessageToken: "",
  invalidEndDateOutOfRangeMessageToken: "",
  invalidStartTimeMessageToken: "wizard.time.invalid",
  midnightBookingOffset: 4,
};

export const gtConfig: GtConfig = {
  navigation: {
    tabIcon: "",
    tabTitleToken: "",
  },
  heading: {
    fixedTitle: false,
    locTitleToken: "",
  },
  elementId: "wizard-gt-pwa",
  lastSearch: {
    useLastSearchForSingleLOB: false,
    lastSearchKey: "",
    lobKey: "",
  },
  location: {
    origin: {
      inputName: "location",
      icon: "place",
      labelToken: locKeys.gtAirport,
      typeaheadLabelToken: locKeys.gtAirport,
      typeaheadEmptyResultPlaceholder: "wizard.typeahead.placeholder.emptyResultPlaceholder.car",
      pwaDialogQueryParam: "origin-car",
      invalidLocationMessageKey: "wizard.origin.warning.invalidOrigin.text",
      essAdapterConfig: {
        lob: "CARS",
        client: "Homepage",
        features: "consistent_display",
        maxResults: 7,
        regionType: 1,
      },
    },
    destination: {
      inputName: "hotelName",
      icon: "lob_hotels",
      labelToken: locKeys.gtProperty,
      typeaheadLabelToken: locKeys.gtProperty,
      typeaheadEmptyResultPlaceholder: "wizard.typeahead.placeholder.emptyResultPlaceholder.car",
      pwaDialogQueryParam: "destination-gt",
      invalidLocationMessageKey: "wizard.destination.warning.invalidDestination.text",
      invalidOriginSameAsDestinationKey: "",
      essAdapterConfig: {
        lob: "CARS",
        client: "Homepage",
        features: "proximity|consistent_display",
        maxResults: 7,
        regionType: 128,
        regionId: undefined,
      },
    },
  },
  toAirportLocation: {
    destination: {
      inputName: "location",
      icon: "place",
      labelToken: locKeys.gtAirport,
      typeaheadLabelToken: locKeys.gtAirport,
      typeaheadEmptyResultPlaceholder: "wizard.typeahead.placeholder.emptyResultPlaceholder.car",
      pwaDialogQueryParam: "origin-car",
      invalidOriginSameAsDestinationKey: "",
      invalidLocationMessageKey: "wizard.origin.warning.invalidOrigin.text",
      essAdapterConfig: {
        lob: "CARS",
        client: "Homepage",
        features: "consistent_display",
        maxResults: 7,
        regionType: 1,
      },
    },
    origin: {
      inputName: "hotelName",
      icon: "lob_hotels",
      labelToken: locKeys.gtProperty,
      typeaheadLabelToken: locKeys.gtProperty,
      typeaheadEmptyResultPlaceholder: "wizard.typeahead.placeholder.emptyResultPlaceholder.car",
      pwaDialogQueryParam: "destination-gt",
      invalidLocationMessageKey: "wizard.destination.warning.invalidDestination.text",
      essAdapterConfig: {
        lob: "CARS",
        client: "Homepage",
        features: "consistent_display",
        maxResults: 7,
        regionType: 128,
        regionId: undefined,
      },
    },
  },
  date: {
    ...commonDateProps,
    start: {
      labelToken: locKeys.gtArrivalDate,
    },
    end: {
      labelToken: locKeys.gtDepartureDate,
    },
    queryParam: {
      start: "pickUpDate",
      end: "dropOffDate",
    },
    dialogId: "departing-returning",
  },
  timeValues,
  additionalSingleDate: {
    ...commonDateProps,
    start: {
      labelToken: locKeys.gtDepartureDate,
    },
    end: {
      labelToken: locKeys.gtDepartureDate,
    },
    queryParam: {
      start: "dropOffDate",
      end: "dropOffDate",
    },
    dialogId: `departing-returning-additional`,
  },
  form: {
    action: "/ground-transfers/search",
    submitButton: {
      locToken: "",
    },
  },
};
